module.exports = __webpack_public_path__ + "img/storedetails@2x.c1f3053.jpg";